module.exports = __webpack_public_path__ + "img/grommet-icons_technology.7973e7a9.svg";